import React, { useEffect,useContext } from "react";
import styles from "../css/Logout.module.css";
import { Link,useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import UserContext from "../context/users/UserContext";


function Logout(props) {
    const history=useHistory();
    const context=useContext(UserContext);
    useEffect(()=>{
        if (!localStorage.getItem("auth-token")) {
            return history.push("/login");
        }
        localStorage.removeItem("auth-token");
        toast.info("Logged out");
        context.setLoggedIn(false);
        
        // eslint-disable-next-line
    },[])
  return (
    ( !context.loggedIn&&<div>
        <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className={styles.container}>
        <h1>You are now logged out.</h1>
        <img
          src="https://c.tenor.com/QFnU4bhN8gMAAAAM/michael-scott-crying.gif"
          alt="good bye gif"
        />
        <div className={styles.homeandlogin}>
          <Link to="/login">Login</Link>
          <Link to="/">or Back Home</Link>
        </div>
      </div>
    </div>)
  );
}

export default Logout;
